import { Box, Center, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import EmptyFile from '../../../../assets/svg/emptyFile'
import Pagination from '../../../Pagination'
import { PagePaginations } from '../../../Pagination/paginations'
import { useGetAllSharedDiagnostics, useGetPatient } from '../../../../api/api_hooks/patients'
import SharedCase from '../../../SharedCaseCard'
import NewRequestModal from '../../NewRequestModal'
import { useTranslation } from 'react-i18next'
import { useTranslatedQueryHook } from '../../../../utils/useTranslatedQueryHook'

export default function PatientHistory() {
  const { data, refetch } = useTranslatedQueryHook(useGetAllSharedDiagnostics())
  const { data: patientData } = useGetPatient()
  const { t } = useTranslation()

  return (
    <Box
      h={'100%'}
      w={'100%'}
      overflowY="auto"
      overflowX="hidden"
      p={{
        base: '32px 16px',
        lg: '32px 100px',
        xl: '32px 120px',
      }}
      bg="gray.50"
    >
      <Flex
        justifyContent={'space-between'}
        alignItems="center"
        mb={6}
        bg="white"
        p={6}
        borderRadius="2xl"
        boxShadow="sm"
      >
        <Box>
          <Heading as="h2" size="xl" fontFamily={'Poppins'} color="gray.800">
            {t('patient.patientHistory')}
          </Heading>
          <Text fontSize="md" mt={2} color="gray.600">
            {t('patient.lastResults')}
          </Text>
        </Box>
        <Box>
          <NewRequestModal
            onRequestCreated={refetch}
            contextPatientId={patientData?.id ? Number(patientData.id) : null}
          />
        </Box>
      </Flex>

      <VStack gap={4}>
        {data?.data?.length ? (
          <>
            {data?.data?.map((sharedDiagnostic) => (
              <SharedCase
                key={sharedDiagnostic.id}
                data={sharedDiagnostic}
                reloadReceivedSharedDiagnostics={refetch}
              />
            ))}
          </>
        ) : (
          <Center gap={3} mt={'100px'} flexDirection="column">
            <EmptyFile />
            <Text fontSize="xl" color={'gray.500'} fontWeight={500}>
              {t('patient.noResults')}
            </Text>
          </Center>
        )}
        <Pagination data={data} pageName={PagePaginations.DIAGNOSTICS_PAGE} />
      </VStack>
    </Box>
  )
}
